import { render, staticRenderFns } from "./DatosEnfermeria.vue?vue&type=template&id=f918ef8c&"
import script from "./DatosEnfermeria.vue?vue&type=script&lang=js&"
export * from "./DatosEnfermeria.vue?vue&type=script&lang=js&"
import style0 from "./DatosEnfermeria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports